var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10755 10.8215L12.0001 4.92896C13.9527 2.97634 17.1186 2.97635 19.0712 4.92897V4.92897C21.0238 6.88159 21.0238 10.0474 19.0712 12L10.8216 20.2496C9.51985 21.5514 7.4093 21.5514 6.10755 20.2496V20.2496C4.80581 18.9479 4.80581 16.8373 6.10755 15.5356L14.4161 7.22706C15.0344 6.60873 16.0369 6.60873 16.6552 7.22706V7.22706C17.2736 7.84539 17.2736 8.8479 16.6552 9.46623L10.7037 15.4177",
    stroke: "#616B85",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.29004dc832ae275db74b1f229028a88f.svg";
export { ForwardRef as ReactComponent };